module.exports = __webpack_public_path__ + "packs/media/images/error-7301bfc956d06372cb4559a4edbe2b06.jpg";